import { Modal as BCModal, ModalContent, ModalOverlay } from '@chakra-ui/react';
import React from 'react';
import FormHOC from './FormHOC';
import { useModals } from '../../../../Services/BetApprovals.hooks';
import Form from './Form';

export default function Modal() {
  const { rejectBetModalOpened, closeRejectBetModal } = useModals();

  return (
    <BCModal
      isOpen={rejectBetModalOpened}
      onClose={() => closeRejectBetModal()}
    >
      <ModalOverlay />
      <ModalContent>
        <FormHOC>
          <Form />
        </FormHOC>
      </ModalContent>
    </BCModal>
  );
}
